import React, { useEffect, useState } from "react";
import { AddUsersWrapper } from "./styled";
import Breadcrumbs from "../../../components/admin/Breadcrumbs/Breadcrumbs";
import {
  BackButton,
  Box,
  ButtonStyled,
  TabsList,
  ThemeLoader,
} from "../../../components/styled/Elements";
import { userFormTabs } from "../../../helpers/adminConstants/AdminConstants";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ContentWrapper } from "../../../components/styled/styled";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import HQBranchesApi from "../../../services/api/hqBranchesApi";
import UsersApi from "../../../services/api/usersApi";
import { toast } from "react-toastify";
import { reqFormatDate } from "../../../utils";
import { useSelector } from "react-redux";

const assetURL = process.env.REACT_APP_ASSET_URL;

const EditUser = () => {
  const navigate = useNavigate();
  const { hqBranchesList } = useSelector((state) => state.helper);
  const { id } = useParams();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const {
    register,
    control,
    handleSubmit,
    trigger,
    watch,
    reset,
    resetField,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  const locationId = watch("location_id");
  const departmentId = watch("department_id");
  const location = watch("location");
  const permissionsObj = {
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
  };

  const [activeTab, setActiveTab] = useState(userFormTabs[0]);
  const [hqBranches, setHqBranches] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [previewImg, setPreviewImg] = useState(null);
  const [secondPreviewImg, setSecondPreviewImg] = useState(null);
  const [initialDepartment, setInitialDepartment] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [permissions, setPermissions] = useState(permissionsObj);
  const [filteredHQBranches, setFilteredHQBranches] = useState([]);
  const [validationFields, setValidationFields] = useState(activeTab.fields);
  const currentTabIndex = userFormTabs.findIndex(
    (tab) => tab.id === activeTab.id
  );
  const handleTabChange = async (tabIndex) => {
    const isValid = await trigger(validationFields);
    if (isValid) {
      setActiveTab(userFormTabs[tabIndex]);
    }
  };

  const handleNext = async () => {
    const isValid = await trigger(validationFields);
    if (isValid) setActiveTab(userFormTabs[currentTabIndex + 1]);
  };

  // const getHqBranches = async () => {
  //   try {
  //     const { data, code } = await HQBranchesApi.getCompleteHQBranchesList();
  //     if (code === 200) {
  //       const resData = data.map((item) => ({
  //         ...item,
  //         departmentName: language === "ar" ? item.name_ar : item.name_en,
  //       }));
  //       setHqBranches(resData);
  //     } else {
  //       setHqBranches([]);
  //     }
  //   } catch (error) {}
  // };

  const getDepartmentsList = async () => {
    try {
      const { data, code } = await HQBranchesApi.getCompleteDepartmentsList(
        locationId
      );
      if (code === 200) {
        const resData = data.map((item) => ({
          ...item,
          name: language === "ar" ? item.name_ar : item.name_en,
          subLabel: language === "en" ? item?.location?.name_en : item?.location?.name_ar,
        }));
        setDepartments(resData);
      } else {
        setDepartments([]);
      }
    } catch (error) {}
  };
  const getSingleDepartment = async (id) => {
    if (!initialDepartment) {
      try {
        const { data, code } = await HQBranchesApi.getSingleDepartment(
          locationId,
          id
        );
        if (code === 200) {
          setValue("location", data?.address);
        }
      } catch (error) {}
    }
  };
  const getSingleUser = async () => {
    try {
      setDataLoading(true);
      const { data, code } = await UsersApi.getSingleUser(id);
      if (code === 200) {
        const uploadId = data.user_detail?.upload_id
          ? `${assetURL}/${data.user_detail?.upload_id}`
          : "";
        const uploadJobId = data.user_detail?.upload_job_id
          ? `${assetURL}/${data.user_detail?.upload_job_id}`
          : "";
        reset({
          user_id: data.id,
          name: data.name || "",
          position: data.position || "",
          id_number: data.user_detail?.id_number || "",
          email: data.email || "",
          phone: data.phone || "",
          location_id: data.user_detail?.location_id || "",
          department_id: data.user_detail?.department_id || "",
          location: data.user_detail?.location || "",
          date_of_birth: data.user_detail?.date_of_birth || "",
          licenses_allowed: data.user_detail?.licenses_allowed || "",
          user_type_id: data.user_type_id || "",
          // permissions: JSON.stringify(data.permissions || {}),
          // upload_id: uploadId,
          // upload_job_id: uploadJobId,
        });

        setInitialDepartment(true);
        const mappedPermissions = data?.user_permissions.reduce((acc, curr) => {
          const type = curr.permission_type_id;
          const operation = curr.permission_operation_id;

          if (!acc[type]) {
            acc[type] = [];
          }
          acc[type].push(operation);

          return acc;
        }, {});

        for (let i = 1; i <= 7; i++) {
          if (!mappedPermissions[i]) {
            mappedPermissions[i] = [];
          }
        }
        Object.keys(mappedPermissions).forEach((type) => {
          const uniqueOperations = [...new Set(mappedPermissions[type])];

          if (uniqueOperations.length === 6) {
            mappedPermissions[type] = ["all", ...uniqueOperations];
          } else {
            mappedPermissions[type] = uniqueOperations;
          }
        });

        setPermissions(mappedPermissions);

        setPreviewImg(uploadId);
        setSecondPreviewImg(uploadJobId);
      }
    } catch (error) {
    } finally {
      setDataLoading(false);
    }
  };

  // useEffect(() => {
  //   getHqBranches();
  // }, [language]);

  useEffect(() => {
    if (locationId) getDepartmentsList();
  }, [locationId]);

  useEffect(() => {
    if (departmentId) getSingleDepartment(departmentId);
  }, [departmentId]);
  useEffect(() => {
    if (id) getSingleUser();
  }, [id]);

  useEffect(() => {
    if (!locationId) {
      setValue("department_id", "");
      setDepartments([]);
    }
  }, [locationId]);

  const onSubmit = async (data) => {
    const permissionsObj = Object.fromEntries(
      Object.entries(permissions).map(([key, value]) => [
        key,
        value.filter((perm) => perm !== "all"),
      ])
    );

    const hasSelectedPermissions = Object.values(permissionsObj).some(
      (perms) => perms.length > 0
    );

    if (!hasSelectedPermissions) {
      toast.error(t("please_select_permission"));
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      // const permissionsArr = Object.entries(permissions).map(([key, value]) =>
      //   value.filter((perm) => perm !== "all")
      // );

      Object.entries(data).forEach(([key, value]) => {
        if (key !== "date_of_birth") formData.append(key, value);
      });
      formData.append("date_of_birth", reqFormatDate(data.date_of_birth));
      formData.append("action", "update");
      formData.append("permissions", JSON.stringify(permissionsObj));
      const { code, message } = await UsersApi.createUser(formData);
      if (code === 200) {
        toast.success(t("user_updated"));
        navigate("/users");
      }
      if (code === 204) {
        toast.error(message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (hqBranchesList.length > 0) {
      let listArr = hqBranchesList?.map((item) => ({
        id: item?.id,
        name: language === "en" ? item?.name_en : item?.name_ar,
      }));

      setFilteredHQBranches(listArr);
    }
  }, [language, hqBranchesList]);

  useEffect(() => {
    const fieldsArr = activeTab?.fields?.filter(
      (item) => item !== "password" && item !== "confirm_password"
    );

    setValidationFields(fieldsArr);
  }, []);

  return (
    <AddUsersWrapper>
      <Box className="content-head">
        <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
          <BackButton
            label={t("edit_user")}
            onClick={() => navigate("/users")}
          />
          <Breadcrumbs />
        </Box>
      </Box>

      <Box>
        <TabsList
          tabs={userFormTabs}
          activeTab={activeTab}
          handleTabChange={handleTabChange}
        />
      </Box>
      <ContentWrapper>
        {dataLoading ? (
          <ThemeLoader />
        ) : (
          <Form onSubmit={handleSubmit(onSubmit)}>
            <activeTab.component
              register={register}
              control={control}
              errors={errors}
              watch={watch}
              resetField={resetField}
              setValue={setValue}
              location={location}
              locationId={locationId}
              departmentId={departmentId}
              hqBranches={filteredHQBranches}
              departments={departments}
              previewImg={previewImg}
              setPreviewImg={setPreviewImg}
              secondPreviewImg={secondPreviewImg}
              setSecondPreviewImg={setSecondPreviewImg}
              setInitialDepartment={setInitialDepartment}
              permissions={permissions}
              setPermissions={setPermissions}
            />
            <Box className="d-flex justify-content-between mx-3 mx-lg-5 py-4">
              <ButtonStyled
                label={t("back")}
                bg="var(--themeColor2)"
                type="button"
                onClick={() => setActiveTab(userFormTabs[0])}
                disabled={activeTab === userFormTabs[0]}
              />
              {activeTab === userFormTabs[0] && (
                <ButtonStyled
                  label={t("next")}
                  type="button"
                  bg="var(--themeColor2)"
                  onClick={handleNext}
                />
              )}
              {activeTab === userFormTabs[1] && (
                <ButtonStyled
                  type="submit"
                  label={t("save_update")}
                  isLoading={loading}
                />
              )}
            </Box>
          </Form>
        )}
      </ContentWrapper>
    </AddUsersWrapper>
  );
};

export default EditUser;
